import React, { useContext, useEffect, useState } from "react";
import CategoryCards from "./CategoryCards/CategoryCards";
import LandingCarousal from "../../Components/Carousal/LandingCarousal";
import TopBargains from "./BestDeal/TopBargains";
import RecentlyVisited2 from "./RecentlyVisited/RecentlyVisited2";
import { UserContext } from "../../Context/UserContext";
import Heading from "../../Components/Heading/Heading";
import Container from "../Container";
import MainPageFeatures from "./MainPageFeatures";
import CategoryFooter from "../Layout/Footer/CategoryFooter";
import Catlog from "./Catlog/Catlog";
import SectDescription from "../../Components/Heading/SectDescription";
import { CartContext } from "../../Context/CartContext";
import { message } from "antd";
import { LoginContext } from "../../Context/LoginContext";
import HomeTrustSections from "./HomeTrustSections";

const Home = () => {
  const { isLogin } = useContext(UserContext);

  const [data, setData] = useState([]);
  const [SkeletonLoad, setSkeletonLoad] = useState(true);
  const skeletonArray = Array.from({ length: 8 }, (_, index) => index);
  const { wishlistCount, setWishlistCount } = useContext(CartContext);
  const [messageApi, contextHolder] = message.useMessage();
  const { setLoginModal } = useContext(LoginContext);
  const getAllCategory = () => {
    setSkeletonLoad(true);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(
      process.env.REACT_APP_HAPS_MEDIA_BASE_URL + "admin/getHomeZoneAppliances",
      // "/admin/getHomeZoneAppliances",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log('result',result);
        if (result.status === 200) {
          setData(result.data);
          setSkeletonLoad(false);
        }
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    getAllCategory();
  }, []);

  useEffect(() => {
    window.scroll(0, 0);
  }, [isLogin]);

  // const handleGetMyLocation = async () => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       async (position) => {
  //         try {
  //           const response = await fetch(
  //             `https://nominatim.openstreetmap.org/reverse?format=json&lat=${position.coords.latitude}&lon=${position.coords.longitude}`
  //           );
  //           const data = await response.json();
  //           // console.log(data);
  //           setPincode(data);
  //         } catch (error) {
  //           // console.log(error);
  //         }
  //       },
  //       (error) => {
  //         console.log(error);
  //       }
  //     );
  //   } else {
  //     console.log("Geolocation is not supported by this browser.");
  //   }
  // };

  // useEffect(() => {
  //   handleGetMyLocation();
  // }, []);

  const [bestDealData, setBestDealDData] = useState([]);
  const skeletonForBestDealArray = Array.from(
    { length: 10 },
    (_, index) => index
  );

  const getBestDeals = async () => {
    setSkeletonLoad(true);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    await fetch(
      process.env.REACT_APP_HAPS_MEDIA_BASE_URL + "general/getBestDeal",
      // "/general/getBestDeal",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        if (result.status === 200) {
          setBestDealDData(result.data);
          setSkeletonLoad(false);
        }
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    getBestDeals();
  }, []);

  const handleHeartClick = async (id) => {
    if (isLogin === false) {
      setLoginModal(true);
    } else {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        product_id: id,
        customer_id: localStorage.getItem("CID"),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        process.env.REACT_APP_HAPS_MEDIA_BASE_URL + "wishlist/wishlistcreate",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          console.log(result);
          if (result.status === 200) {
            setWishlistCount(parseInt(wishlistCount + 1));
            getBestDeals();
            success();
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  const deleted = () => {
    messageApi.error("Removed From Wishlist!");
  };
  const success = () => {
    messageApi.success("Added To Wishlist!");
  };
  const handleDeleteWishlist = async (el) => {
    var requestOptions = {
      method: "DELETE",
      redirect: "follow",
    };

    await fetch(
      process.env.REACT_APP_HAPS_MEDIA_BASE_URL +
      `wishlist/deletewishlist/${el.whishlist_id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          setWishlistCount(parseInt(wishlistCount - 1));
          getBestDeals();
          deleted();
          // setLoading(false);
        }
      })
      .catch((error) => console.log("error", error));
  };

  return (
    <Container className="mt-2 md:mt-2 lg:mt-0 error-message">
      {contextHolder}
      <LandingCarousal />
      <div className="my-10">
        <p className="text-center text-xs font-bold uppercase text-[#858653]">
          Curated for your home
        </p>
        <h1 className="mx-auto mt-2 max-w-3xl text-center text-2xl font-semibold text-gray-900 md:text-4xl">
          Furniture and interiors, considered as one
        </h1>
        <p className="mx-auto mt-3 max-w-2xl px-4 text-center text-sm leading-6 text-gray-600 md:text-base">
          Explore pieces and complete interior solutions selected for beautiful,
          comfortable everyday living.
        </p>
        <CategoryCards
          linkTo="/sub-category"
          data={data}
          SkeletonLoad={SkeletonLoad}
          skeletonArray={skeletonArray}
          className="grid grid-cols-3 md:grid-cols-5 xl:grid-cols-8 gap-x-[10px] md:gap-x-[50px] gap-y-1 md:gap-y-4 cursor-pointer"
        />
      </div>
      <HomeTrustSections />
      <MainPageFeatures />
      <Catlog />
      {/* <MainPageTestimonials /> */}
      <Heading spanHeading={`Top Bargains`} />
      <SectDescription SectDescription="Big savings, stylish spaces: explore 'Top Bargains' for your dream home interiors." />
      <TopBargains
        bestDealData={bestDealData}
        skeletonForBestDealArray={skeletonForBestDealArray}
        SkeletonLoad={SkeletonLoad}
        handleHeartClick={handleHeartClick}
        handleDeleteWishlist={handleDeleteWishlist}
      />
      <CategoryFooter Category={data} />
      {isLogin === true ? <RecentlyVisited2 ProductsPerView={10} /> : false}
    </Container>
  );
};

export default Home;
